var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCafeGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4787_42041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6367 54.987V46.6536L20.3034 49.987H31.9701L38.6367 44.987L48.6367 43.3203L60.3034 44.987L58.6367 56.6536L53.6367 64.987L43.6367 69.987H30.3034L18.6367 64.987L13.6367 54.987Z",
    fill: "#E3E6ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6367 46.6555C16.4034 48.7955 20.5601 50.0455 25.3034 49.9888C30.0467 50.0455 34.2034 48.7955 36.9701 46.6555C39.7367 44.5155 43.8934 43.2655 48.6367 43.3222C53.3801 43.2655 57.5367 44.5155 60.3034 46.6555",
    stroke: "#E3E6ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.296 10C29.2411 10.7572 28.3863 11.7599 27.8055 12.9214C27.2248 14.0829 26.9355 15.3683 26.9627 16.6667C26.9355 17.965 27.2248 19.2504 27.8055 20.4119C28.3863 21.5734 29.2411 22.5761 30.296 23.3333",
    stroke: "#C8CEDA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6476 10C42.5926 10.7572 41.7378 11.7599 41.1571 12.9214C40.5763 14.0829 40.2871 15.3683 40.3143 16.6667C40.2871 17.965 40.5763 19.2504 41.1571 20.4119C41.7378 21.5734 42.5926 22.5761 43.6476 23.3333",
    stroke: "#C8CEDA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6367 33.3203H60.3034V49.987C60.3034 55.2913 58.1963 60.3784 54.4455 64.1291C50.6948 67.8798 45.6077 69.987 40.3034 69.987H33.6367C28.3324 69.987 23.2453 67.8798 19.4946 64.1291C15.7439 60.3784 13.6367 55.2913 13.6367 49.987V33.3203Z",
    stroke: "#C8CEDA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4609 55.7678C60.9496 56.4512 62.5833 56.7584 64.2186 56.6625C65.8538 56.5666 67.4404 56.0705 68.8389 55.2177C70.2375 54.365 71.4052 53.1817 72.2393 51.772C73.0734 50.3623 73.5485 48.7692 73.6227 47.1329C73.6969 45.4965 73.3681 43.867 72.665 42.3875C71.9619 40.9081 70.9062 39.624 69.5906 38.6481C68.275 37.6722 66.7398 37.0345 65.12 36.7909C63.5002 36.5473 61.8454 36.7053 60.3009 37.2511",
    stroke: "#C8CEDA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4787_42041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCafeGray);
export default __webpack_public_path__ + "static/media/icon-cafe-gray.c34489cc7e7ee00ec8e043b951938d92.svg";
export { ForwardRef as ReactComponent };